<template>

    <div class="form-group">
        <label v-if="label">{{ label }}</label>
        <slot></slot>
    </div>

</template>

<style scoped lang="scss">

    .form-group {
        margin-bottom: 20px;
        text-align: left;
        label {
            @include font-semibold(13px);
            color: $color-text;
            display: block;
            margin-bottom: 10px;
        }
    }

</style>

<script>

export default {

    props: {
        label: {
            type: String,
        },
    },

}

</script>